import {
  BasicButton,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  SectionMessage,
  Stack,
  Text,
} from "@certn/cascadia-react";
import { FormEvent } from "react";
import { Trans, useTranslation } from "react-i18next";
interface Props {
  show: boolean;
  onClose: () => void;
  handleSubmit: (e?: FormEvent<HTMLFormElement> | undefined) => void;
}

export function SaveModal(props: Props) {
  const { show, onClose, handleSubmit } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen={show}>
      <Dialog>
        <>
          <DialogHeader onClose={onClose}>{t("Disclaimer")}</DialogHeader>
          <DialogContent>
            <Stack>
              <SectionMessage
                icon="verified_user"
                sectionTitle={t("Privacy is important to us")}
                type="success"
              >
                <Text style="form/body-primary">
                  <Trans>
                    You should only collect information that is needed to
                    complete your applicant’s check.
                  </Trans>
                </Text>
              </SectionMessage>
              <Text style="form/body-primary">
                <Trans>
                  By proceeding, you acknowledge and agree that Certn will not
                  be held liable for your failure to comply with your legal
                  obligations (including, without limitation, under privacy and
                  human rights laws) as a property manager.
                </Trans>
              </Text>
            </Stack>
          </DialogContent>
          <DialogFooter>
            <ButtonGroup>
              <BasicButton
                testID="cancel-template-modal"
                size="medium"
                onPress={() => onClose()}
              >
                <Trans>Cancel</Trans>
              </BasicButton>
              <PrimaryButton
                testID="save-template-modal"
                type="submit"
                onPress={() => {
                  handleSubmit();
                  onClose();
                }}
                size="medium"
              >
                <Trans>Agree and save</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </DialogFooter>
        </>
      </Dialog>
    </Modal>
  );
}
